export enum FreeSpaceMode {
	Classic			= 1,
	Optimized		= 2,
	SemiOptimized	= 3
}
